import { generatePopup } from "../../utility/popup";
import * as actionTypes from "../ActionTypes";
import { apiGet } from "../axios";

export const getLoanType = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_LOAN_TYPE_INIT,
    });

    try {
      const response = await apiGet(
        `loan-types?page=${payload?.page}&limit=${payload?.limit}`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_LOAN_TYPE_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_LOAN_TYPE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_LOAN_TYPE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};
